/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NamespaceRelationshipEdge } from './NamespaceRelationshipEdge';
import type { NamespaceRelationshipSummary } from './NamespaceRelationshipSummary';

export type ListNamespaceRelationshipsOutput = {
    cluster_id: string;
    namespace_id?: (string | null);
    direction: ListNamespaceRelationshipsOutput.direction;
    include_indirect: boolean;
    namespaces: Array<NamespaceRelationshipSummary>;
    relationships: Array<NamespaceRelationshipEdge>;
};

export namespace ListNamespaceRelationshipsOutput {

    export enum direction {
        PARENTS = 'parents',
        CHILDREN = 'children',
        BOTH = 'both',
    }


}

